import './index.scss';

import React from 'react';

import TrackOrderImage from '../../../assets/images/track-order.png';
import OnTheWayImage from '../../../assets/images/trackorder-on-the-way.png';
import PreparingImage from '../../../assets/images/trackorder-preparing-order.png';


import { getRightArrowImage } from '../../utils/imageChanges';

const getTitle = (status,cart_added_for) => {
  if(status === 'PENDING') return 'Confirming your order';
  if(status === 'ACCEPTED' || status === 'PREPARED') return 'Preparing your order';
  if(status === 'DISPATCHED' && cart_added_for === 'takeaway') return 'Order ready for pickup';
  return 'On the way';
}

const getText = (status,cart_added_for) => {
  if(status === 'PENDING') return 'Your order has been received';
  if(status === 'ACCEPTED' || status === 'PREPARED') return 'Your order will be ready for delivery shortly';
  if(status === 'DISPATCHED' && cart_added_for === 'takeaway') return 'Your order is at the restaurant counter. Show any of our cashiers this screen to receive it';
  return 'Your order is on its way to your address';
}

const getImage = status => {
  if(status === 'PENDING') return TrackOrderImage;
  if(status === 'ACCEPTED' || status === 'PREPARED') return PreparingImage;
  return OnTheWayImage;
}

const OngoingOrder = props => {
  const { theme, data, onClick } = props;
  const { status,cart_added_for } = data;
  return (
    <div
      className='ongoing-order u_cursor_pointer'
      role="presentation"
      onClick={() => onClick(data)}
    >
      <div className="ongoing-order__details">
        <p className="ongoing-order__title">{getTitle(status,cart_added_for)}<span className="ongoing-order__arrow"><img src={getRightArrowImage(theme)} alt='right arrow' /></span></p>
        <div className="ongoing-order__text">{getText(status,cart_added_for)}</div>
      </div>
      <div className="ongoing-order__image">
        <img src={getImage(status)} alt="status" className="ongoing-order__img" />
      </div>
    </div>
  )
}

export default OngoingOrder;